<template>
    <ColumnaIzquierda></ColumnaIzquierda>
    <EnvioDocumentos></EnvioDocumentos>
</template>
<script>
import ColumnaIzquierda from '../components/ColumnaIzquierda.vue';
import EnvioDocumentos from '../components/EnvioDocumentos.vue';
export default {
    name: 'SendView',
    components: {
        ColumnaIzquierda,
        EnvioDocumentos,
    }
}
</script>